import React from 'react';
import PropTypes from 'prop-types';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import clsx from 'clsx';
import SavingIndicator from '../SavingIndicator';
import RemovingIndicator from '../RemovingIndicator';
import styles from './ReviseBundleDialog.style';

const ReviseBundleDialog = ({
  onDismiss,
  onSubmit,
  isSubmitting,
  className,
  dialogContentProps,
  dialogBodyContent,
  isRemoving,
  ...other
}) => (
  <Dialog
    dialogContentProps={dialogContentProps}
    modalProps={{
      className: clsx(styles.root, className),
    }}
    onDismiss={onDismiss}
    onSubmit={onSubmit}
    isSubmitting={isSubmitting}
    {...other}
  >
    <p className={styles.modalText}>{dialogBodyContent?.content}</p>
    <DialogFooter>
      {dialogBodyContent?.showCancelButton && (
        <DefaultButton onClick={onDismiss}>Cancel</DefaultButton>
      )}
      <PrimaryButton type="submit" onClick={onSubmit}>
        {dialogBodyContent?.buttonText}
      </PrimaryButton>
      {isSubmitting && <SavingIndicator className={styles.saving} />}
      {isRemoving && <RemovingIndicator />}
    </DialogFooter>
  </Dialog>
);

ReviseBundleDialog.propTypes = {
  onDismiss: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  isRemoving: PropTypes.bool,
  className: PropTypes.string,
  dialogContentProps: PropTypes.shape({
    type: PropTypes.number,
    title: PropTypes.string,
    closeButtonAriaLabel: PropTypes.string,
  }),
  dialogBodyContent: PropTypes.shape({
    content: PropTypes.string,
    showCancelButton: PropTypes.bool,
    buttonText: PropTypes.string,
  }),
};

ReviseBundleDialog.defaultProps = {
  isSubmitting: false,
  isRemoving: false,
  className: 'normal',
  dialogContentProps: {
    type: DialogType.close,
    title: '',
    closeButtonAriaLabel: 'Close',
  },
  dialogBodyContent: {
    content: '',
    showCancelButton: false,
    buttonText: 'Close',
  },
};

export default ReviseBundleDialog;
